// extracted by mini-css-extract-plugin
export default {"inputLabel":"DeleteTenantForm_inputLabel__nX0IG","subdomain":"DeleteTenantForm_subdomain__Shz6A"};